import { BaseWorkflowTaskState, WorkflowTaskResponse, WriteWorkflowTaskModel } from "../../../api/clients/workflowTasks/DTOs"
import { SignalResource } from "../../../api/clients/workflows/DTOs"

export type InteractiveWorkflowTaskResult = {
	result: 'okay' | 'cancel'
	signalTypeId: string
	resources: SignalResource[]
}

export type InteractiveWorkflowTaskState<T = unknown> = {
	resourceId: string
	interactionData: T
} & BaseWorkflowTaskState

export type IInteractiveWorkflowTaskProps<T = WriteWorkflowTaskModel<BaseWorkflowTaskState>> = {
	task: T
	onConfirm: (result: InteractiveWorkflowTaskResult) => void
	onCancel: (result: InteractiveWorkflowTaskResult) => void
}

export interface IInteractiveWorkflowTask<T extends WriteWorkflowTaskModel<BaseWorkflowTaskState> = WriteWorkflowTaskModel<BaseWorkflowTaskState>> {
	id: string
	interaction: (props: IInteractiveWorkflowTaskProps<T>) => JSX.Element
}

export const isInteractiveWorkflowTask = (workflowTask: WorkflowTaskResponse<BaseWorkflowTaskState>): workflowTask is WriteWorkflowTaskModel<InteractiveWorkflowTaskState> => {
	return (
		"resourceId" in workflowTask.workflowTaskState && "interactionData" in workflowTask.workflowTaskState
	)
}